export const chapters = [
  {
    id: 9,
    part: 1,
    englishTitle: "Deadly is the Viper",
    kanjiTitle: "毒蛇は致命的だ",
    romanizedTitle: "Dokumaru wa Shinu",
    available: false,
    content: `Content for Deadly is the Viper...`,
 }
];